import React, { useState } from 'react'
import SideMenu from '../../../../Components/SideDrawer';
import { Container, Form, Row, Col, Button, Table } from 'react-bootstrap';
import PageHeader from '../../../../Components/Header';
import { truckTripReport } from '../../../../Api/Admin/AdminApi';
import { extractErrorMessage } from '../../../../Utils/ErrorUtlis';
import { formatDate } from '../../../../Utils/DateUtlis';


const TruckTripReport = () => {
  const [apiData, setApiData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const initialData = {
    startDate: '',
    endDate: ''
  }
  const [formData, setFormData] = useState(initialData);


  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(`${name}: ${value}`);
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await truckTripReport(formData);
      if (response.results) {
        const truckTripReport = response.results.map(i => ({
          _id: i._id,
          trip_date: i.trip_date,
          emp_id: i.emp_id,
          NAME: i.NAME,
          trip_cost: i.trip_cost,
          trip_pay: i.trip_pay,
          remarks: i.remarks,
        }));
        setApiData(truckTripReport);
        setIsLoading(true);
      }
    } catch (err) {
      const errorMessage = extractErrorMessage(err);
      console.log('Error in Getting Truck Trip Report ', errorMessage || err);
      alert(errorMessage);
    }
    setFormData(initialData);
  }
  return (
    <div>
      <SideMenu />
      <Container fluid style={{
        marginLeft: '250px',
        padding: '20px',
        transition: 'margin 0.3s ease',
        width: 'calc(100% - 250px)'
      }}>
        <PageHeader title='Truck Trip Report By Date' showButtons={true} />
        <h4 className="mb-4 d-flex justify-content-between align-items-center">
          Truck Trip Details
        </h4>
        <Form onSubmit={handleSubmit} className='mt-4'>
          <Row className='mb-3'>
            <Form.Group as={Col} md='4' controlId='startDate'>
              <Form.Label>Starting Date</Form.Label>
              <Form.Control
                type='date'
                name='startDate'
                value={formData.startDate}
                onChange={handleChange}
                required
              >
              </Form.Control>
            </Form.Group>
            <Form.Group as={Col} md="4" controlId='endDate'>
              <Form.Label>Ending Date</Form.Label>
              <Form.Control
                type='date'
                name='endDate'
                value={formData.endDate}
                onChange={handleChange}
                required
              >
              </Form.Control>
            </Form.Group>
            <Form.Group as={Col} md='4' className="text-center">
              <Button type="submit" variant="primary" className="d-flex align-items-center mb-2" style={{ marginTop: '25px', height: '30px' }}>
                Get Details
              </Button>
            </Form.Group>
          </Row>
        </Form>
        {!isLoading ? <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
          <div role="status">
            <span className="sr-only">No Data to Show</span>
          </div>
        </div> : <div tyle={{ overflow: 'auto' }}>
          <Table striped hover responsive='sm' size="sm">
            <thead>
              <tr>
                <th className="fs-12">Driver Name</th>
                <th className="fs-12">Trip Date</th>
                <th className="fs-12">Trip Cost</th>
                <th className="fs-12">Trip Pay</th>
                <th className="fs-12">Remarks</th>
              </tr>
            </thead>
            <tbody>
              {apiData.map((emp, i) => (
                <tr key={emp.emp_id}>
                  <td className="fs-12">
                    {emp.NAME}
                  </td>
                  <td className="fs-12">
                    {formatDate(emp.trip_date)}
                  </td>
                  <td className="fs-12">
                    {emp.trip_cost}
                  </td>
                  <td className="fs-12">
                    {emp.trip_pay}
                  </td>
                  <td className="fs-12">
                    {emp.remarks}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
        }
      </Container>
    </div>
  );
}

export default TruckTripReport;